import React from "react";
import Snackbar from "@mui/material/Snackbar";
import { useDispatch, useSelector } from "react-redux";
import IconButton from "@mui/material/IconButton";
import success from "../../components/assets/images/successIcon.svg";
import erroriconn from "../../../../assets/images/error-35.svg"
import warning from "../../../../assets/images/warning-60.svg"
import CloseIconSVG from "../../../../assets/images/CloseIconSVG";
import { closeSnackbar } from "../../../../features/snackbar/snackbarslice"

import "./Snackbar.css";

const SnackbarComponent = () => {
  const { snackbar } = useSelector((state) => state);
  const dispatch = useDispatch();

  const getIconAndColor = () => {
    switch (snackbar.type) {
      case "error":
        return { icon: <img src={erroriconn} alt="Error"/>, color: "#EF0707", title: "Error" };
      case "warning":
        return { icon: <img src={warning} alt="warning"/>, color: "#FFB665", title: "Warning" };
      case "success":
      default:
        return { icon: <img src={success} alt="Success"/>, color: "#00CA9F", title: "Success" };
    }
  };

  return (
    <>
      <Snackbar
        className={`snackbar snackbarMain${snackbar.type.charAt(0).toUpperCase() + snackbar.type.slice(1)}`}
        open={snackbar.open}
        message={snackbar.message}
        autoHideDuration={snackbar.autoHideDuration}
        anchorOrigin={snackbar.anchorOrigin}
        onClose={() => dispatch(closeSnackbar())}
        action={
          <React.Fragment>
            <div className="titleContent">
              <div className="messageTitle">
                {getIconAndColor().icon}
                <h3>{getIconAndColor().title}</h3>
              </div>
              <IconButton aria-label="close" color="#ffffff" sx={{ p: 0.5 }} onClick={() => dispatch(closeSnackbar())}>
                <CloseIconSVG color="#A0A4A8" />
              </IconButton>
            </div>
          </React.Fragment>
        }
      />
    </>
  );
};

export default SnackbarComponent;
